import type { Obligation } from '@avalara/types/ztb';

export const isPaidReturnsForSmallBusinessObligation = ({ itemName, price }: Obligation): boolean =>
  itemName.startsWith('Returns for Small Business') && !!price && price > 0;

export const isTrialReturnsForSmallBusinessObligation = ({ itemName, price }: Obligation): boolean =>
  itemName.startsWith('Returns for Small Business') && price === 0;

export const isManagedReturnsObligation = ({ itemName }: Obligation): boolean => itemName.includes('Managed Returns');

export const isBasicReturnsObligation = (obligation: Obligation): boolean =>
  obligation.itemName.includes('Basic Returns') || isPaidReturnsForSmallBusinessObligation(obligation);
